import * as _ from 'lodash';
import * as hash from 'object-hash';
import { useContext, useEffect, useReducer } from 'react';
import { connect, Dispatch } from 'react-redux';
import { IApplicationState, AppActionCreators, RecipientActionCreators, IAppState, IRecipientPairedDonorsListResponse } from '@nkr/store/index';
import { AfterAction, RecipientProfileContext } from '../models';
import { pairedDonorsReducer, initialState } from './state';
import { ProfileWrapper } from '../styles';
import Content from './content';

interface IProps {
    saveRef: React.MutableRefObject<any>
}

interface IStateProps {
    app: IAppState
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getPairedDonors: (centerId: number, recipientId: number) => Promise<IRecipientPairedDonorsListResponse>,
}

type TProps = IProps & IStateProps & IDispatchProps;

const PairedDonors = (props: TProps) => {
    const context = useContext(RecipientProfileContext);
    const [state, dispatch] = useReducer(pairedDonorsReducer, initialState);

    useEffect(() => {
        getData();
    }, []);

    const getData = () => {
        props.showLoading('Getting paired donors, one moment please....').then(() => {
            props.getPairedDonors(context.centerId, context.recipientId).then(response => {
                let data = response.data.results;

                dispatch({
                    type: 'afterLoad',
                    value: {
                        data,
                        hash: hash(data),
                    }
                });
            }).catch(() => {

            }).finally(() => {
                props.hideLoading();
            });
        });
    };

    const handleSave = (afterAction: AfterAction) => {
    };

    context.registerSave(props.saveRef, handleSave);

    if (state.data == null || context.headerInfo == null)
        return null;

    return (
        <ProfileWrapper>
            <Content
                centerId={context.centerId}
                recipientId={context.recipientId}
                isTransplanted={context.headerInfo.isTransplanted}
                data={state.data}
            />
        </ProfileWrapper>
    );
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        app: state.app
    };
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getPairedDonors: (centerId, recipientId) => {
            return dispatch(RecipientActionCreators.getPairedDonors(centerId, recipientId))
        },
    }
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(PairedDonors);


